module.exports = __webpack_public_path__ + "img/16.9ce84f9d.jpg";